import { RichText } from '@sitecore-jss/sitecore-jss-react';
import React, { FC } from 'react';
import { appendRootToRichTextInternalLinks } from '../../../utils/appendRootToRichTextInternalLinks.utils';
import { appendToUrlPath } from '../../../utils/link.utils';
import Picture from '../../@shared/picture';
import RoutableNotEditableLink from '../../@shared/routableNotEditableLink';
import { TLoaderContent } from '../types/contentHubCompatibleLoaders.types';

const LoaderContent: FC<TLoaderContent> = (props) => {
  const { baseUrl, tabs, hiddenTabs, selectedTab, showMoreLoaders } = props;

  const modelCards = (loader) => {
    const loaderDescription = appendRootToRichTextInternalLinks(loader?.shortDescription);

    return (
      <RoutableNotEditableLink
        key={loader?.id}
        href={appendToUrlPath(baseUrl || '', loader?.url || '')}
        onClick={(e) => !loader?.url && e.preventDefault()}
        className={`ch-compatible-loaders__link ${!loader?.url ? 'ch-compatible-loaders__link--none' : ''} `}
      >
        <Picture
          productImageProps={{
            desktopRendition: loader?.assets?.[0]?.rendition_desktop_size500,
            mobileRendition: loader?.assets?.[0]?.rendition_mobile_size500,
            alt: loader?.assets?.[0]?.alt,
            imageClassName: 'ch-compatible-loaders__card-image',
          }}
        />
        <h4 className={'ch-compatible-loaders__card-title'}>{loader?.title}</h4>
        <RichText tag={'div'} className={'ch-compatible-loaders__card-text rich-text'} field={{ value: loaderDescription }} />
      </RoutableNotEditableLink>
    );
  };

  return (
    <section className={'ch-compatible-loaders__content'}>
      {!hiddenTabs ? (
        tabs
          .find((_, index: number) => index === selectedTab)
          ?.items?.filter((_, index) => (!showMoreLoaders && index < 4) || showMoreLoaders)
          ?.map(modelCards)
      ) : (
        <>
          {tabs
            ?.map((item) => item?.items)
            .reduce((acc, val) => acc.concat(val), [])
            .filter((_, index) => (!showMoreLoaders && index < 4) || showMoreLoaders)
            .map(modelCards)}
        </>
      )}
    </section>
  );
};

export default LoaderContent;
